import React, { useEffect } from "react";
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import "./App.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import confetti from "canvas-confetti";

import Login from "./pages/Login/Login";
import Sales from "./pages/SalesTeam/Sales";
import Header from "./components/Header/Header";
import Home from "./pages/Home/Home";
import SalesForm from "./components/Forms/SalesForm";
import Estimation from "./pages/Estimation/Estimation";
import SalesOrder from "./pages/SalesOrder/SalesOrder";
import Management from "./pages/Management/Management";
import "react-toastify/dist/ReactToastify.css";
import Customer from "./pages/Customer/Customer";


function App() {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const protectedPaths = [
      "/sales-enq-list",
      "/customer",
      "/estimation",
      "/sales-order",
      "/management"
    ];

    const currentPath = location.pathname;
    const isProtected = protectedPaths.includes(currentPath);

    if (isProtected) {
      const pathToPageMap = {
        "/sales-enq-list": "sales-enq-list",
        "/customer": "customer",
        "/estimation": "estimation",
        "/sales-order": "sales-order",
        "/management": "management"
      };

      const pageKey = pathToPageMap[currentPath];
      const isLoggedIn = localStorage.getItem(`${pageKey}-isLoggedIn`) === "true";

      if (!isLoggedIn) {
        navigate(`/login?page=${pageKey}`);
      }
    }
    // ✅ WON Notification Logic
    const notification = sessionStorage.getItem("wonNotification");

    if (notification) {
      const data = JSON.parse(notification);

      toast.success(
        <div className="won-toast">
          <div className="won-header">🎉 Order Won!</div>
          <div className="won-company">{data.name}</div>
          <div className="won-assign">
            Assigned to <b>{data.assignedTo}</b>
          </div>
        </div>,
        {
          position: "top-right",
          autoClose: 5000
        }
      );
      // 🎊 CONFETTI CELEBRATION
      confetti({
        particleCount: 250,
        spread: 360,
        startVelocity: 40,
        origin: { x: 0.5, y: 0.4 }
      });
      // remove after showing
      sessionStorage.removeItem("wonNotification");
    }
  }, [location.pathname, navigate]);


  return (
    <div className="App">

      <ToastContainer
        position="top-right"
        autoClose={false}
        closeOnClick
        pauseOnHover
        draggable
      />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/navbar" element={<Header />} />
        <Route path="/sales-enq-list" element={<SalesForm />} />
        <Route path="/customer" element={<Customer />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/estimation" element={<Estimation />} />
        <Route path="/sales-order" element={<SalesOrder />} />
        <Route path="/management" element={<Management />} />
      </Routes>

    </div>
  );
}

export default App;
